export const visit = (vm, at) => {
vm(require("hubspot-prosemirror/lang/en.lyaml"));
vm(require("react-colorpicker/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("payment-link-components/lang/en.lyaml"));
vm(require("data-quality-ui-library/lang/en.lyaml"));
vm(require("react-colorpicker/lang/en.lyaml"));
vm(require("reporting-enablement/lang/en.lyaml"));
vm(require("reference-resolvers-lite/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("property-translator/lang/en.lyaml"));
vm(require("reporting-data/lang/en.lyaml"));
vm(require("reporting-ui-components/lang/en.lyaml"));
vm(require("reporting-reports/lang/en.lyaml"));
vm(require("reporting-snowflake/lang/en.lyaml"));
vm(require("reporting-visualizations/lang/en.lyaml"));
vm(require("customer-data-filters/lang/en.lyaml"));
vm(require("customer-data-filters-ui/lang/en.lyaml"));
vm(require("customer-data-reference-ui-components/lang/en.lyaml"));
vm(require("ui-addon-i18n/lang/en.lyaml"));
vm(require("ui-addon-opt/lang/en.lyaml"));
vm(require("SharedI18nStrings/lang/countryCodes/en.lyaml"));
vm(require("SharedI18nStrings/lang/languageNames/en.lyaml"));
vm(require("SharedI18nStrings/lang/regionCodes/en.lyaml"));
vm(require("ui-shepherd-react/lang/en.lyaml"));
vm(require("ui-addon-teams/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("ui-addon-teams/lang/en.lyaml"));
vm(require("ui-business-units-lib/lang/en.lyaml"));
vm(require("dashboard-lib/lang/en.lyaml"));
vm(require("dashboard-components/lang/en.lyaml"));
vm(require("ui-asset-management-lib/lang/en.lyaml"));
vm(require("timezone-utils/lang/en.lyaml"));
vm(require("ExportDialog/lang/en.lyaml"));
vm(require("sales-analytics-lib/lang/en.lyaml"));
vm(require("slack-ui-library/lang/en.lyaml"));
vm(require("reports-list-components/lang/en.lyaml"));
vm(require("reporting-action-components/lang/en.lyaml"));
vm(require("analytics-tools-lib/lang/en.lyaml"));
vm(require("ui-addon-video-player/lang/en.lyaml"));
vm(require("ai-components-ui-library/lang/en.lyaml"));
at({ "en": { "reports-list-app": { "placeholder": "Placeholder" } } });
};